export default __webpack_public_path__ + "static/media/banner_home.076d2612.jpg";